import * as React from "react";

import { ButtonStyle } from "./button.style";
import { WebcamSvg } from "../../assets/dynamic-icons";

interface ButtonProps {
  call?: boolean;
  colors: any;
  onClick?(): void;
}

export const Button: React.FunctionComponent<ButtonProps> = ({ call, colors, children, onClick }) => {
  return (
    <ButtonStyle onClick={onClick} backgroundColor={colors.buttonsBackground} textColor={colors.buttonsText}>
      {call && <div className="webcam-icon" dangerouslySetInnerHTML={{ __html: WebcamSvg }} />}

      <div className={"webcam-text"}>{children}</div>
    </ButtonStyle>
  );
};

// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/button/button.tsx
